export default {
  global: {
    '*': {
      boxSizing: 'border-box',
      fontFamily: 'body',
      fontSize: 'md',
      margin: 0,
      padding: 0,

      h1: { fontSize: { base: '3xl', md: '4xl', xl: '5xl' } },
      h2: { fontSize: { base: '2xl', md: '3xl', xl: '4xl' } },
      h3: { fontSize: { base: 'xl', md: '2xl', xl: '3xl' } },
      h4: { fontSize: { base: 'lg', md: 'xl', xl: '2xl' } },
    },
    body: {
      minHeight: '100vh',
      minWidth: '320px',
      overflowX: 'hidden',
      '&.loading': { cursor: 'wait' },

      // Makes fonts more palatable in Chrome/Webkit based browsers.
      WebkitFontSmoothing: 'antialiased',
    },
    label: {
      // This is the only way I could find to style a labels required indicator.
      'span[aria-hidden=true][role="presentation"]': {
        color: 'red.500',
        fontSize: ['xs'],
        fontWeight: '600',
        marginLeft: '2px',
      },
    },
  },
}
